import { twJoin } from 'tailwind-merge';
import { tv } from 'tailwind-variants';

export const useTabNavStyles = () => {
  return {
    tabStyle: tv({
      base: twJoin(
        'relative pb-[21px]',
        'transition-all duration-300',
        'outline-none',
        'data-[focus]:bg-black data-[focus]:bg-opacity-5',
        'disabled:text-gray-400',
      ),
      variants: {
        selected: {
          false: twJoin('data-[hover]:font-semibold'),
          true: twJoin(
            'cursor-default select-none',
            'before:z[1] before:absolute',
            'font-semibold before:-inset-[1.1px]',
            'before:border-b-2 before:border-primary',
            `before:content-['']`,
          ),
        },
      },
      defaultVariants: { selected: false },
    }),
  };
};
